module.exports = __webpack_public_path__ + "img/videoBg.65dbf841.png";